module.exports = __webpack_public_path__ + "img/1557614060995944451.e203e4f5.png";